export const MISSION_COPY = {
  sectionLabel: 'A módszer',
  quote:
    'Amit ajánlunk, azt magunk is használjuk: minden projektünk AI-alapú munkafolyamatban készül, és minden döntés szenior kézben van. Ezért tudja ma egy kis stúdió elvégezni azt, amihez régen egy egész fejlesztőcsapat kellett. A legutóbbi projektjeink mind így készültek, hetek alatt, és ma is naponta használják őket: lejjebb meg is találod mindet.',
} as const
